import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SERVICES } from "../data/content";
import { scrollToId } from "../lib/scroll";

const FINISHES = [
  {
    name: "HD Makeup",
    copy: "High-definition, skin-like perfection. Specially formulated products create a flawless base that softens imperfections without a trace — as beautiful in person as it is through the lens.",
  },
  {
    name: "Airbrush Makeup",
    copy: "A fine mist of foundation applied with a precision airgun — impossibly smooth, feather-light and exceptionally long-lasting, from the morning ceremony to the last dance.",
  },
];

export const Services = () => (
  <section id="services" data-testid="section-services" className="py-24 sm:py-32 bg-[#F4EBDD]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
        <div>
          <Eyebrow index="02">Services</Eyebrow>
          <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6 text-[#2A1F16]">
            For every <em className="text-[#96754D]">occasion</em> that matters
          </h2>
        </div>
        <p className="text-[15px] text-[#6B5A49] max-w-xs leading-relaxed">
          Every booking begins with a conversation — share your date and vision, and receive a
          tailored quote.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className="h-full">
            <article
              data-testid="service-card-item"
              className="group h-full bg-[#FFFCF7] border border-[#E9DCC8] rounded-2xl overflow-hidden flex flex-col hover:border-[#B8893B]/50 hover:shadow-[0_20px_50px_-25px_rgba(42,31,22,0.25)] transition-[border-color,box-shadow] duration-500"
            >
              <div className="overflow-hidden h-56">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.2s] ease-out"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif-ed text-xl sm:text-2xl text-[#2A1F16]">{s.title}</h3>
                <p className="mt-1.5 font-serif-ed italic text-[#B8893B]/90 text-[15px]">{s.tagline}</p>
                <p className="mt-3 text-sm leading-relaxed text-[#6B5A49] flex-1">{s.copy}</p>
                <button
                  data-testid={`service-enquire-${i}`}
                  onClick={() => scrollToId("inquire")}
                  className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#2A1F16] group-hover:text-[#B8893B] transition-colors duration-300 self-start"
                >
                  Enquire
                  <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div data-testid="finish-panel" className="mt-16 border-t border-[#E9DCC8] pt-14">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16">
            {FINISHES.map((f, i) => (
              <div key={f.name} data-testid={`finish-${f.name.toLowerCase().replace(/\s/g, "-")}`}>
                <p className="font-serif-ed italic text-[#B8893B] text-lg">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="font-serif-ed text-2xl sm:text-3xl text-[#2A1F16] mt-2">{f.name}</h3>
                <p className="mt-4 text-sm leading-relaxed text-[#6B5A49]">{f.copy}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 text-[15px] text-[#9C8871] max-w-xl leading-relaxed">
            Not sure which finish is right for you? Every booking begins with a personal
            consultation — we'll decide together, based on your skin, your event and your light.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
